import ReducerRegistry from '../base/redux/ReducerRegistry';
import { CLEAR_RECORDING_SESSIONS, RECORDING_SESSION_UPDATED, SET_MEETING_HIGHLIGHT_BUTTON_STATE, SET_PENDING_RECORDING_NOTIFICATION_UID, SET_SELECTED_RECORDING_SERVICE, SET_STREAM_KEY } from './actionTypes';
const DEFAULT_STATE = {
    disableHighlightMeetingMoment: false,
    pendingNotificationUids: {},
    selectedRecordingService: '',
    sessionDatas: []
};
/**
 * The name of the Redux store this feature stores its state in.
 */
const STORE_NAME = 'features/recording';
/**
 * Reduces the Redux actions of the feature features/recording.
 */
ReducerRegistry.register(STORE_NAME, (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case CLEAR_RECORDING_SESSIONS:
            return Object.assign(Object.assign({}, state), { sessionDatas: [] });
        case RECORDING_SESSION_UPDATED:
            return Object.assign(Object.assign({}, state), { sessionDatas: _updateSessionDatas(state.sessionDatas, action.sessionData) });
        case SET_PENDING_RECORDING_NOTIFICATION_UID: {
            const pendingNotificationUids = Object.assign({}, state.pendingNotificationUids);
            pendingNotificationUids[action.streamType] = action.uid;
            return Object.assign(Object.assign({}, state), { pendingNotificationUids });
        }
        case SET_SELECTED_RECORDING_SERVICE: {
            return Object.assign(Object.assign({}, state), { selectedRecordingService: action.selectedRecordingService });
        }
        case SET_STREAM_KEY:
            return Object.assign(Object.assign({}, state), { streamKey: action.streamKey });
        case SET_MEETING_HIGHLIGHT_BUTTON_STATE:
            return Object.assign(Object.assign({}, state), { disableHighlightMeetingMoment: action.disabled });
        default:
            return state;
    }
});
/**
 * Updates the known information on recording sessions.
 *
 * @param {Array} sessionDatas - The current sessions in the redux store.
 * @param {Object} newSessionData - The updated session data.
 * @private
 * @returns {Array} The session datas with the updated session data added.
 */
function _updateSessionDatas(sessionDatas, newSessionData) {
    const hasExistingSessionData = sessionDatas.find(sessionData => sessionData.id === newSessionData.id);
    let newSessionDatas;
    if (hasExistingSessionData) {
        newSessionDatas = sessionDatas.map(sessionData => {
            if (sessionData.id === newSessionData.id) {
                return Object.assign({}, newSessionData);
            }
            // Nothing to update for this session data so pass it back in.
            return sessionData;
        });
    }
    else {
        // If the session data is not present, then there is nothing to update
        // and instead it needs to be added to the known session datas.
        newSessionDatas = [
            ...sessionDatas,
            Object.assign({}, newSessionData)
        ];
    }
    return newSessionDatas;
}
